import { IPreviousApplicantDetails } from '@nx-ng/types/previous-applicant-details';
import { ApplicantCustomer } from '../client/src';

export const getPreviousApplicantsDetails = (
  applicants?: ApplicantCustomer[]
): IPreviousApplicantDetails[] => {
  const previousApplicantsInfo: IPreviousApplicantDetails[] = [];
  if (applicants) {
    applicants.forEach((applicant: ApplicantCustomer) => {
      previousApplicantsInfo.push({
        firstName: applicant.firstName,
        lastName: applicant.lastName,
        fullName: `${applicant.title} ${applicant.firstName} ${applicant.lastName}`,
        id: applicant.id,
        dateOfBirth: new Date(applicant.dateOfBirth),
      });
    });
  }

  return previousApplicantsInfo;
};
